import { useResultPopupModuleDispatch, RESULT_POPUP_MODULE_ACTION, POPUP_TYPE } from "..";
import { useIsConferenceOver } from "../../game/hooks/use-is-conference-over";
import { useUserModuleState } from "../../user";
import { useEffect } from "react";

export default function useEndingPopupCheck() {

    const dispatch = useResultPopupModuleDispatch();
    const isConferenceOver = useIsConferenceOver();
    const { gameEnded } = useUserModuleState();

    useEffect(() => {
        if (gameEnded && !isConferenceOver) {
            dispatch({
                type: RESULT_POPUP_MODULE_ACTION.SHOW,
                payload: {
                    type: POPUP_TYPE.TIME_END
                }
            })
        }
    }, [gameEnded, dispatch, isConferenceOver])
}
